<template>
  <el-container>
    <el-header>
      <el-menu
        style="height: 100%"
        :default-active="$route.path"
        mode="horizontal"
        background-color="#baa364"
        text-color="#fff"
        active-text-color="#fff"
        router
      >
        <el-menu-item index="/index/music">
          音乐赏析
        </el-menu-item>
        <el-menu-item index="/index/my">
          关于我们
        </el-menu-item>
        <el-menu-item index="/index/system">
          自审制度
        </el-menu-item>
      </el-menu>
      <div class="logo"><img src="@/assets/imgs/logo.png" alt="" /></div>
    </el-header>
    <img class="top-img" src="@/assets/imgs/index-top.png" alt="">
    <div class="index-text">
      <p class="index-text-top">QINGSONG  MUSIC &nbsp;&nbsp; PC</p>
      <p class="index-text-bottom">轻松音乐 &nbsp;&nbsp; 大有不同</p>
    </div>
    <el-main style="padding: 0">
      <router-view></router-view>
    </el-main>
    <el-footer style="height: 100%">
      <div class="bottom-message">
        <p>@深圳市轻松信息科技有限公司</p>
        <p>电话：0755-36640500</p>
        <p>地址：广东省深圳市龙华区龙华街道松和社区东环一路108号油松科技大厦B栋3层B322</p>
      </div>
      <div class="bottom-copyright">
        <p>版权声明：所有音乐、节目视频均已授权，侵者必究</p>
        <p>备案号：粤ICP备2021069348号-1</p>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {
    }
  },
}
</script>
<style scoped>
.el-container {
  position: relative;
}
.el-header {
  width: 100%;
  padding: 0 360px;
  background-color: #baa364;
  align-items: center;
  display: flex;
}
.logo {
  width: 130px;
  height: 38px;
  margin: 0 auto;
}
.el-header img {
  width: 100%;
  height: 100%;
}
.top-img {
  width: 100%;
  height: 100%;
}
.index-text {
  position: absolute;
  top: 200px;
  left: 360px;
  line-height: 59px;
  color: #fff;
  font-weight: bold;
}
.index-text-top {
  font-size: 36PX;
}
.index-text-bottom {
  font-size: 24PX;
}

.el-footer {
  width: 100%;
  padding: 34px 360px;
  color: #fff;
  background-color: #baa364;
  
}
.bottom-message {
  font-size: 18PX;
  line-height: 30px;
  margin-bottom: 20px;
}
.bottom-copyright {
  font-size: 14PX;
  line-height: 24px;
}
</style>
